import React from "react";
import { ShimmeredDetailsList, Stack, Text } from "sprint-common-web";

import { createLookupHistoryListColumns } from "./createLookupHistoryListColumns";
import { SubmissionsHistoryContent, useLookupHistory } from "./useLookupHistory";

export type LookupHistoryItem = SubmissionsHistoryContent;

interface LookupHistoryListProps {
    onClick: (item: LookupHistoryItem) => void;
}

export const LookupHistoryList = ({ onClick }: LookupHistoryListProps): JSX.Element => {
    const lookupHistory = useLookupHistory();

    const historySubmissions = lookupHistory.read();

    const columns = createLookupHistoryListColumns({ onItemClicked: onClick });

    const items = historySubmissions;

    return (
        <Stack style={{ overflowY: "auto", height: 400 }}>
            {items.length ? (
                <ShimmeredDetailsList columns={columns} items={items} layoutMode="justified" shimmerLines={3} />
            ) : (
                <Text>No history</Text>
            )}
        </Stack>
    );
};
